import React, { useEffect } from "react";
import { Link } from "gatsby";
import Seo from "../seo";
import ValuesIconsWithLabel from "../components/icons/ValuesIconsWithLabel";
import { StaticImage } from "gatsby-plugin-image";
import HomeStyles from "../styles/HomeStyles";
import PillButton from "../components/buttons/PillButton";
import ArticleCarousel from "../components/layout/ArticleCarousel";

const Home = () => {
  useEffect(() => {
    //find offset of second section (where text animation will take place on scroll into view)
    document.addEventListener("scroll", addTextAnimationClass);

    const rect = document
      .querySelector(".process-card")
      .getBoundingClientRect();

    const offset = {
      top: rect.top + window.scrollY,
    };

    const windowHeight = window.innerHeight;

    //determine at what scroll point text fade in/up animation should be triggered
    const scrollPosToTriggerAnimation =
      Math.floor(offset.top) - windowHeight / 2;

    function addTextAnimationClass() {
      if (window.scrollY >= scrollPosToTriggerAnimation) {
        //collect elements to add animation class to in second section
        const targetElementsArr = [];
        targetElementsArr.push(document.querySelector("#point-one"));
        targetElementsArr.push(document.querySelector("#point-two"));
        targetElementsArr.push(document.querySelector("#point-three"));
        targetElementsArr.push(document.querySelector("#about-process-btn"));

        //add class to trigger animation
        targetElementsArr.forEach(element => {
          element.classList.add("animate-text");
        });
        //remove event listener
        document.removeEventListener("scroll", addTextAnimationClass);
      }
    }

    //when component unmounts
    return function () {
      //remove event listeners
      document.removeEventListener("scroll", addTextAnimationClass);
    };
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Seo
        title="Table Sage | Dine well. Do good."
        description="Curated restaurants for the conscious diner"
        url="https://www.table-sage.com"
        image="https://res.cloudinary.com/table-sage/image/upload/f_auto/v1628259927/general-assets/logo-black-bg-w_yji0cu.png"
        imageWidth="500"
      />
      <HomeStyles>
        <section className="top-section">
          <header className="intro-text">
            <h1 className="top-header no-wrap">
              <span className="dine-well">Dine well.</span>
              <span className="do-good">Do good.</span>
            </h1>
            <p className="top-description">
              <span>
                Finding the right restaurant is hard. We do the work so you can
                focus on what matters.
              </span>
            </p>
            <PillButton
              targetUrl="/locate"
              buttonText="Search restaurants"
              buttonFontColor="#000"
              buttonBgColor="#F0FD9D"
              buttonHoverBg="#231f20"
              buttonHoverFont="#F0FD9D"
            />
          </header>
          <div className="phone-screen-container">
            <Link to="/locate">
              <div className="phone-bezel-and-vid">
                <video
                  poster=""
                  className="phone-screen-video"
                  loop="loop"
                  muted
                  playsInline
                  autoPlay
                >
                  <source
                    type="video/mp4"
                    src="https://res.cloudinary.com/table-sage/video/upload/c_scale,q_auto:good,w_867/v1630413504/ts-homepage/sept-screen-rec-v5_zowgjh.mp4"
                  />
                  <source
                    type="video/webm"
                    src="https://res.cloudinary.com/table-sage/video/upload/c_scale,q_auto:good,w_867/v1630413504/ts-homepage/sept-screen-rec-v5_zowgjh.webm"
                  />
                </video>
                <StaticImage
                  src="https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_993/v1630406309/ts-homepage/iphone-frame_x2bwwn.png"
                  alt=""
                  placeholder="none"
                  objectFit="contain"
                  className="phone-screen"
                  loading="eager"
                />
              </div>
            </Link>
          </div>
        </section>
        <section className="second-section">
          <div className="graphic-card">
            <p>
              What people expect<br></br> from restaurants is evolving to
              include more than just great food
            </p>
            <StaticImage
              src="https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:best,w_1099/v1628771284/ts-homepage/V1_-_transparent_ajyyln.png"
              alt="Table Sage five-values graphic of concentric circles showing the three levels of Conscious Dining values- from Cuisine in the center to Experience and Story in the second circle to Sustainability and Diversity in the outer most circle"
              placeholder="none"
              objectFit="contain"
              className="circle-graphic"
            />
          </div>
          <div className="process-card">
            <div className="point" id="point-one">
              <h2>1</h2>
              <p>
                <span className="bold-text">
                  Our team selects only the best restaurants
                </span>{" "}
                and evaluates them on the five elements of conscious dining,
                plus other unique factors
              </p>
            </div>
            <div className="point" id="point-two">
              <h2>2</h2>
              <p>
                <span className="bold-text">
                  You find recommended restaurants
                </span>{" "}
                in our database that meet your needs, and reflect your values
              </p>
            </div>
            <div className="point" id="point-three">
              <h2>3</h2>
              <p className="mb-6">
                <span className="bold-text">We collectively support</span> a
                healthier and more inclusive food system
              </p>
            </div>
            <PillButton
              targetUrl="/values"
              buttonText="About our process"
              buttonFontColor="#FFF"
              buttonBgColor="#231f20"
              buttonHoverBg="transparent"
              buttonHoverFont="#231f20"
              id="about-process-btn"
            />
          </div>
        </section>
        <section className="third-section">
          <img
            src="https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1616506302/top-banners/about-banner_rqisw7.jpg"
            alt="Beautiful open space with high ceilings, and brick walls at the best Amsterdam restaurant- FENTO, Mexican food"
          />
          <div className="text-over-image">
            <div className="image-text-box">
              <p>
                <span>
                  A delicious meal is undeniably better when you add great
                  atmosphere and a story. But why stop there?
                </span>
              </p>
              <p>
                <span>
                  Support restaurants that also benefit your community and the
                  planet.
                </span>
              </p>
            </div>
            <PillButton
              targetUrl="/locate"
              buttonText="Search restaurants"
              buttonFontColor="#000"
              buttonBgColor="#F0FD9D"
              buttonHoverBg="#231f20"
              buttonHoverFont="#F0FD9D"
            />
          </div>
        </section>
        <section className="fourth-section">
          <div className="impact-card">
            <div>
              <h2>
                The restaurants you choose to support can shape the future.
              </h2>
              <p>Our vision is an industry that goes beyond just good food.</p>
              <p>
                Together, we encourage restaurants to expand their measures of
                success by celebrating those that put an emphasis on sustainable
                practices and diversity of leadership.
              </p>
            </div>
            <PillButton
              targetUrl="/theory-of-change"
              buttonText="About our impact"
              buttonFontColor="#FFF"
              buttonBgColor="#231f20"
              buttonHoverBg="transparent"
              buttonHoverFont="#231f20"
            />
          </div>
          <div className="values-card">
            <div>
              <p>
                We make it easy<br></br> for you to choose<br></br> meals that
                have a<br></br> positive impact
              </p>
              <div className="values-card__item">
                <ValuesIconsWithLabel icon="cuisine" label={true} />
                <ValuesIconsWithLabel icon="experience" label={true} />
                <ValuesIconsWithLabel icon="story" label={true} />
                <ValuesIconsWithLabel icon="sustainability" label={true} />
                <ValuesIconsWithLabel icon="diversity" label={true} />
              </div>
            </div>
          </div>
        </section>
        {/* <section className="articles-section">
          <h2>Learn more about your local food scene</h2>
          <p>
            Looking for the latest in food news, interviews, and restaurant recs
            for all occasions? We’ve got you covered.
          </p>
          <ArticleCarousel />
          <PillButton
            targetUrl="/content/best-of/amsterdam"
            buttonText="Explore featured content"
            buttonFontColor="#FFF"
            buttonBgColor="#231f20"
            buttonHoverBg="transparent"
            buttonHoverFont="#231f20"
          />
        </section> */}
        <section className="partner-section">
          <div>
            <h2>Partner with us</h2>
            <p>
              Do you represent an eatery, brand, or public institution that is
              working towards a more sustainable and inclusive future?
            </p>
            <p>Explore our services and mission driven partnerships.</p>
          </div>
          <PillButton
            targetUrl="/partnerships"
            buttonText="Learn more"
            buttonFontColor="#000"
            buttonBorderColor="#000"
            buttonHoverBg="#231f20"
            buttonHoverFont="#fff"
          />
        </section>
        <section className="featured-on">
          <h2>Featured on</h2>
          <div className="logos">
            <a
              href="https://www.sarahlindaforrer.com/journal/2021/2/20/the-world-is-changing-so-must-restaurant-ratings"
              rel="noreferrer noopener"
              target="_blank"
              className="featured-on-logo"
              id="sarah-linda-logo"
            >
              <StaticImage
                src="../assets/images/sarah-linda-logo.png"
                alt="Sarah Linda logo"
                placeholder="blurred"
                layout="constrained"
              />
            </a>
            <a
              href="https://www.iamsterdam.com/en/blog/people/serena-weaver"
              rel="noreferrer noopener"
              target="_blank"
              className="featured-on-logo"
              id="iamsterdam-logo"
            >
              <StaticImage
                src="../assets/images/Iamsterdam.png"
                alt="Iamsterdam logo"
                placeholder="blurred"
                layout="constrained"
              />
            </a>
            <a
              href="https://mezpiration.nl/table-sage-het-platform-voor-restaurants-die-niet-de-beste-maar-beter-willen-zijn/"
              rel="noreferrer noopener"
              target="_blank"
              className="featured-on-logo"
              id="mezpiration-logo"
            >
              <StaticImage
                src="../assets/images/mezpiration.png"
                alt="Mezpiration logo"
                placeholder="blurred"
                layout="constrained"
              />
            </a>
            <a
              href="https://amsterdam.impacthub.net/startups/join-an-accelerator/"
              rel="noreferrer noopener"
              target="_blank"
              className="featured-on-logo"
              id="impact-hub-logo"
            >
              <StaticImage
                src="../assets/images/impact-hub.png"
                alt="Impact Hub logo"
                placeholder="blurred"
                layout="constrained"
              />
            </a>
            <a
              href="https://www.iamexpat.nl/lifestyle/lifestyle-news/new-dining-platform-seeks-transform-our-food-system"
              rel="noreferrer noopener"
              target="_blank"
              className="featured-on-logo"
              id="iamexpat-logo"
            >
              <StaticImage
                src="../assets/images/iamexpat.png"
                alt="IAMEXPAT logo"
                placeholder="blurred"
                layout="constrained"
              />
            </a>
            <a
              href="https://founderfax.com/how-i-started-a-restaurant-rating-platform/"
              rel="noreferrer noopener"
              target="_blank"
              className="featured-on-logo"
              id="founder-facts-logo"
            >
              <StaticImage
                src="../assets/images/founder-facts.png"
                alt="Founder Facts logo"
                placeholder="blurred"
                layout="constrained"
              />
            </a>
          </div>
        </section>
      </HomeStyles>
    </>
  );
};

export default Home;
